var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveMirrorIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 29.6,
    rx: 4.5,
    fill: "#006AB3",
    stroke: "#006AB3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.86426,
    y: 5.42188,
    width: 15.1358,
    height: 15.1358,
    rx: 0.809524,
    fill: "#7AAFD3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.00002,
    y: 8.04836,
    width: 15.9453,
    height: 15.9453,
    rx: 1.21429,
    fill: "#F5F5F5",
    stroke: "#006AB3",
    strokeWidth: 0.809524
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMirrorIconNew);
export default __webpack_public_path__ + "static/media/activeMirrorIconNew.6e7b835ff48e2d3e377102234e95d3d8.svg";
export { ForwardRef as ReactComponent };